import { render, staticRenderFns } from "./SignupOmniTalk.vue?vue&type=template&id=19aa236d&scoped=true"
import script from "./SignupOmniTalk.vue?vue&type=script&lang=js"
export * from "./SignupOmniTalk.vue?vue&type=script&lang=js"
import style0 from "./SignupOmniTalk.vue?vue&type=style&index=0&id=19aa236d&prod&scoped=true&lang=css"
import style1 from "./SignupOmniTalk.vue?vue&type=style&index=1&id=19aa236d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa236d",
  null
  
)

export default component.exports